const fonts = {
    body: "AktivGrotesk, system-ui, sans-serif",
    heading: "AktivGrotesk, serif",
    mono: "AktivGrotesk, monospace",
};

export default fonts;
